<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-bg-light is-min-height-50">
      <div class="column is-padding-left">
        <span class="is-size-6">{{users.length}} utilisateur(s) associé(s)</span>
        <span class="is-size-3 is-margin-left-xsmall"
              v-helper.right.medium="'42lfeNvsw8Npw3UL3MS5iq'">
          <i class="fas fa-question-circle fa-xs has-text-grey"></i>
        </span>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched" v-if="sourceUser">
        <router-link class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey has-text-normal"
          :to="{name: 'UserCreate', query: {referent: sourceUser.pk}}">
          <span class="icon"><i class="fal fa-user-plus"></i></span>
          <span>Créer un utilisateur</span>
        </router-link>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched" v-if="sourceUser">
        <a class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey has-text-normal"
          @click="openUserQuickView">
          <span class="icon"><i class="fal fa-user-plus"></i></span>
          <span>Associer un utilisateur</span>
        </a>
      </div>
    </div>
    <table
      class="table is-fullwidth is-last-fixed-small is-marginless-bottom is-radius-bottom-left is-radius-bottom-right"
      v-if="users && users.length">
      <thead>
      <tr class="is-size-6">
        <th>Utilisateur</th>
        <th>Action</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(s, i) in users" :key="s.email" class="is-size-6">
        <td class="is-cell-hoverable">
          <router-link :to="{name: 'UserVue', params: {id: s.pk}}" class="fullLink" v-if="s.pk">
            <avatar :item="s" :i="i" class="is-margin-right-xsmall"></avatar>
            <span>{{s.first_name}} {{s.last_name}}</span>
          </router-link>
          <span v-else>{{s.first_name}} {{s.last_name}}</span>
        </td>
        <td class="actions has-text-right">
          <a @click="deleteUser(s)" class="button is-circle is-white is-small" :class="{'disabled': s._removed }">
            <i class="fas fa-user-minus"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    name: 'LinkedUsersList',
    data () {
      return {
        notLinkedUser: []
      }
    },
    props: {
      sourceLinkedUsers: {
        type: Array,
        required: true
      },
      sourceUser: {
        type: Object
      }
    },
    computed: {
      ...mapState(['quickview']),
      users () {
        return this.sourceLinkedUsers
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION' && params.type === 'referentToSeller') {
            this.addReferentToUser(results.entities)
          }
        }
      }
    },
    methods: {
      openUserQuickView () {
        let params = {
          mode: 'append',
          facets: {
            USER: ['is_operator:False', 'is_editor:False', 'is_admin:False', 'has_referent:False']
          },
          type: 'referentToSeller'
        }
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params})
      },
      addReferentToUser (users) {
        users.forEach((user, i) => {
          this.$api.userService.patch(user.pk, {referent: this.sourceUser.pk}).then(user => {
            if (i === users.length - 1) {
              this.$emit('updateSourceLinkedUsers')
              this.$notify({
                type: 'is-success',
                text: 'Référent ajouté au utilisateurs'
              })
            }
          })
        })
      },
      deleteUser (user) {
        this.$set(user, '_removed', true)
        if (user.picture && !user.picture.path) user.picture = null
        this.$api.userService.put(user.pk, {...user, referent: null}).then(user => {
          this.$emit('updateSourceLinkedUsers')
          this.$notify({
            type: 'is-success',
            text: 'Référent supprimé à l\'utilisateurs'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la suppression du référent de l\'utilisateurs'
          })
          this.$set(user, '_removed', false)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/LinkedUsersList.vue